// src/components/Home.js

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaComments,
  FaCloud,
  FaQuoteLeft,
  FaRobot,
  FaChevronDown,
  FaChevronUp,
  FaPaperPlane,
  FaArrowRight,
  FaGithub,
  FaTwitter,
  FaLinkedin,
  FaDiscord,
  FaUsers,
  FaChartLine,
  FaLock,
  FaSearch,
  FaEllipsisV,
  FaPaperclip,
  FaSmile,
  FaMicrophone,
  FaPhoneAlt,
  FaVideo,
  FaCheckDouble,
  FaMicrosoft,
  FaCheck,
  FaCode,
  FaLanguage,
  FaHistory,
  FaBars,
  FaTimes,
  FaMobileAlt,
  FaFileAlt,
  FaBolt,
  FaShieldAlt,
  FaRocket,
  FaSun,
  FaMoon
} from "react-icons/fa";
import {
  SiGooglecloud,
  SiFirebase,
  SiReact,
  SiOpenai,
  SiNodedotjs
} from "react-icons/si";
import AOS from "aos";
import "aos/dist/aos.css";
import IntegrationReport from "./IntegrationReport";
import "./Home.css";

function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [aiDemoTab, setAiDemoTab] = useState("summary");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showTopBanner, setShowTopBanner] = useState(true);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  useEffect(() => {
    AOS.init({ duration: 900, once: true });

    const handleScroll = () => {
      if (window.scrollY > 40) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleFaq = (idx) => {
    setOpenFaq(openFaq === idx ? null : idx);
  };

  return (
    <div className="home-v3">
      {/* 🌌 Aurora Background Mesh & Particles */}
      <div className="aurora-bg"></div>

      {/* 🚀 1. BODHAI STYLE TOP ANNOUNCEMENT BAR */}
      {showTopBanner && (
        <div className="v3-bodh-announcement-bar">
          <div className="v3-bodh-announcement-container">
            <div className="v3-bodh-left">
              <span className="v3-bodh-pill">
                <span className="v3-bodh-dot"></span> Bharat Connect v3.0 is Live
              </span>
              <span className="v3-bodh-bold">New Sampark AI Engine Active</span>
              <span className="v3-bodh-desc">AI-powered messaging upgraded.</span>
              <a href="#v3-announcement" className="v3-bodh-link">What's New</a>
            </div>
            <button 
              className="v3-bodh-close" 
              onClick={() => setShowTopBanner(false)}
              aria-label="Dismiss Announcement"
              title="Close"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* 🧭 2. NAVBAR (Unscrolled Full-Width -> Scrolled Floating Pill) */}
      <nav className={`v3-navbar ${scrolled ? "scrolled" : ""}`}>
        <Link to="/" className="v3-logo">
          <span style={{ fontSize: "1.3rem" }}>🇮🇳</span>
          <span>Bharat Connect</span>
        </Link>

        <ul className="v3-nav-links">
          <li><a href="#features">Features</a></li>
          <li><a href="#analytics">Live Analytics</a></li>
          <li><a href="#ai">Bharat AI</a></li>
          <li><Link to="/docs">Docs</Link></li>
        </ul>

        <div className="v3-nav-actions">
          <button 
            className="v3-theme-btn"
            onClick={toggleTheme}
            title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
            aria-label="Toggle Theme"
          >
            {theme === "dark" ? <FaSun style={{ color: '#eab308' }} /> : <FaMoon style={{ color: '#00a884' }} />}
          </button>
          <Link to="/login" style={{ color: "var(--bc-text-muted)", textDecoration: "none", fontWeight: 600, fontSize: "0.9rem" }}>
            Login
          </Link>
          <Link to="/register" className="v3-nav-btn">
            Get Started
          </Link>
        </div>

        {/* 📱 Mobile Hamburger Toggle Button */}
        <button
          className="v3-mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle Navigation Menu"
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* 📱 Mobile Glass Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="v3-mobile-dropdown">
            <a href="#features" className="v3-mobile-item" onClick={() => setMobileMenuOpen(false)}>
              <FaComments className="v3-mobile-item-icon" /> <span>Features</span>
            </a>
            <a href="#analytics" className="v3-mobile-item" onClick={() => setMobileMenuOpen(false)}>
              <FaChartLine className="v3-mobile-item-icon" /> <span>Live Analytics</span>
            </a>
            <a href="#ai" className="v3-mobile-item" onClick={() => setMobileMenuOpen(false)}>
              <FaRobot className="v3-mobile-item-icon" /> <span>Bharat AI</span>
            </a>
            <Link to="/docs" className="v3-mobile-item" onClick={() => setMobileMenuOpen(false)}>
              <FaFileAlt className="v3-mobile-item-icon" /> <span>Docs</span>
            </Link>
            <div className="v3-mobile-menu-divider"></div>
            <div className="v3-mobile-menu-actions">
              <button 
                className="v3-theme-btn"
                onClick={toggleTheme}
                title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
                aria-label="Toggle Theme"
                style={{ flexShrink: 0 }}
              >
                {theme === "dark" ? <FaSun style={{ color: '#eab308' }} /> : <FaMoon style={{ color: '#00a884' }} />}
              </button>
              <Link to="/login" className="v3-mobile-menu-btn secondary" onClick={() => setMobileMenuOpen(false)}>Login</Link>
              <Link to="/register" className="v3-mobile-menu-btn primary" onClick={() => setMobileMenuOpen(false)}>Get Started</Link>
            </div>
          </div>
        )}
      </nav>

      {/* 🚀 2. HERO SECTION (100vh) */}
      <section className="v3-hero">
        <div className="v3-container v3-hero-grid">
          <div className="v3-hero-content" data-aos="fade-right">
            <div className="v3-badge">
              <FaRobot /> Bharat Connect v3.0 • Powered by Sampark AI
            </div>
            <h1 className="v3-hero-title">
              India's Intelligent <br />
              <span className="v3-gradient-text">Messaging Platform</span>
            </h1>
            <p className="v3-hero-desc">
              Build • Chat • AI • Collaborate. Real-time messaging engineered for modern teams, creators, and developers across India.
            </p>

            <div className="v3-hero-actions">
              <Link to="/register" className="v3-btn-primary">
                Get Started Free <FaArrowRight />
              </Link>
              <a href="#demo" className="v3-btn-secondary">
                Watch Live Demo
              </a>
            </div>
          </div>

          {/* 🟢 RESPONSIVE WHATSAPP MOCKUP (PC vs MOBILE) */}
          <div className="wa-hero-wrap" data-aos="fade-left" data-aos-delay="200">
            
            {/* 💻 1. WHATSAPP DESKTOP/LAPTOP SPLIT VIEW (>= 992px) */}
            <div className="wa-desktop-frame">
              <div className="wa-desktop-sidebar">
                <div className="wa-sidebar-header">
                  <div className="wa-avatar">🇮🇳</div>
                  <FaEllipsisV style={{ color: "var(--wa-text-sub)", cursor: "pointer" }} />
                </div>
                <div className="wa-sidebar-search">
                  <div className="wa-search-input">
                    <FaSearch />
                    <span>Search or start new chat</span>
                  </div>
                </div>
                <div className="wa-chat-list">
                  <div className="wa-chat-item active">
                    <div className="wa-avatar" style={{ background: "linear-gradient(135deg, #3b82f6, #8b5cf6)" }}>P</div>
                    <div className="wa-chat-info">
                      <div className="wa-chat-name">Priya Sharma <span className="wa-chat-time">12:01 PM</span></div>
                      <div className="wa-chat-last">Verified across all Indian nodes...</div>
                    </div>
                  </div>
                  <div className="wa-chat-item">
                    <div className="wa-avatar" style={{ background: "#10b981" }}>R</div>
                    <div className="wa-chat-info">
                      <div className="wa-chat-name">Rahul Kumar <span className="wa-chat-time">11:45 AM</span></div>
                      <div className="wa-chat-last">Sub-100ms sync rate is live!</div>
                    </div>
                  </div>
                  <div className="wa-chat-item">
                    <div className="wa-avatar" style={{ background: "var(--bc-purple)" }}>🤖</div>
                    <div className="wa-chat-info">
                      <div className="wa-chat-name">Sampark AI Hub <span className="wa-chat-time">11:30 AM</span></div>
                      <div className="wa-chat-last">10-message memory active.</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="wa-desktop-main">
                <div className="wa-chat-header">
                  <div className="wa-header-user">
                    <div className="wa-avatar" style={{ background: "linear-gradient(135deg, #3b82f6, #8b5cf6)" }}>P</div>
                    <div>
                      <div className="wa-header-name">Priya Sharma</div>
                      <div className="wa-header-status">online</div>
                    </div>
                  </div>
                  <div className="wa-header-icons">
                    <FaVideo />
                    <FaPhoneAlt />
                    <FaSearch />
                    <FaEllipsisV />
                  </div>
                </div>

                <div className="wa-message-stream">
                  <div className="wa-bubble outgoing">
                    Hi Priya! Have you checked out Bharat Connect v3? 🚀
                    <div className="wa-bubble-meta">
                      <span>12:00 PM</span>
                      <FaCheckDouble className="wa-check-ticks" />
                    </div>
                  </div>

                  <div className="wa-bubble ai-mention">
                    🤖 <strong>Sampark AI:</strong> Thread summary ready! Realtime analytics, PWA installation, and 10-message continuity active.
                    <div className="wa-bubble-meta">
                      <span>12:00 PM</span>
                    </div>
                  </div>

                  <div className="wa-bubble outgoing">
                    That sub-100ms sync speed is incredible. ⚡
                    <div className="wa-bubble-meta">
                      <span>12:01 PM</span>
                      <FaCheckDouble className="wa-check-ticks" />
                    </div>
                  </div>

                  <div className="wa-bubble ai-mention">
                    🤖 <strong>Sampark AI:</strong> Verified across all Indian network nodes with 99.99% SLA uptime.
                    <div className="wa-bubble-meta">
                      <span>12:01 PM</span>
                    </div>
                  </div>
                </div>

                <div className="wa-composer">
                  <FaSmile className="wa-composer-icon" />
                  <FaPaperclip className="wa-composer-icon" />
                  <input
                    type="text"
                    className="wa-composer-input"
                    placeholder="Type a message or @SamparkAI..."
                    readOnly
                    value="Type a message or @SamparkAI..."
                  />
                  <FaMicrophone className="wa-composer-icon" />
                  <FaPaperPlane className="wa-composer-icon" style={{ color: "var(--wa-accent-green)" }} />
                </div>
              </div>
            </div>

            {/* 📱 2. WHATSAPP MOBILE PHONE VIEW (< 992px) */}
            <div className="wa-mobile-frame">
              <div className="wa-mobile-status-bar">
                <span>12:00</span>
                <span>Bharat Connect LTE</span>
                <span>100%</span>
              </div>
              <div className="wa-chat-header" style={{ padding: "8px 14px" }}>
                <div className="wa-header-user">
                  <div className="wa-avatar" style={{ width: "32px", height: "32px", fontSize: "0.8rem" }}>P</div>
                  <div>
                    <div className="wa-header-name" style={{ fontSize: "0.85rem" }}>Priya Sharma</div>
                    <div className="wa-header-status" style={{ fontSize: "0.7rem" }}>online</div>
                  </div>
                </div>
              </div>

              <div className="wa-message-stream" style={{ padding: "12px" }}>
                <div className="wa-bubble outgoing" style={{ fontSize: "0.8rem" }}>
                  Hi Priya! Have you checked out Bharat Connect v3? 🚀
                  <div className="wa-bubble-meta">
                    <span>12:00 PM</span>
                    <FaCheckDouble className="wa-check-ticks" />
                  </div>
                </div>

                <div className="wa-bubble ai-mention" style={{ fontSize: "0.8rem" }}>
                  🤖 <strong>Sampark AI:</strong> Thread summary ready! Realtime analytics & 10-msg memory active.
                  <div className="wa-bubble-meta">
                    <span>12:00 PM</span>
                  </div>
                </div>

                <div className="wa-bubble outgoing" style={{ fontSize: "0.8rem" }}>
                  That sub-100ms sync speed is incredible. ⚡
                  <div className="wa-bubble-meta">
                    <span>12:01 PM</span>
                    <FaCheckDouble className="wa-check-ticks" />
                  </div>
                </div>

                <div className="wa-bubble ai-mention" style={{ fontSize: "0.8rem" }}>
                  🤖 <strong>Sampark AI:</strong> Verified with 99.99% SLA uptime.
                  <div className="wa-bubble-meta">
                    <span>12:01 PM</span>
                  </div>
                </div>
              </div>

              <div className="wa-composer" style={{ padding: "8px 12px" }}>
                <input
                  type="text"
                  className="wa-composer-input"
                  placeholder="Type a message..."
                  readOnly
                />
                <FaPaperPlane style={{ color: "var(--wa-accent-green)" }} />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 🏢 3. TRUSTED BY INFINITE MARQUEE WITH REAL SVG BRAND ICONS */}
      <section className="marquee-section">
        <div className="marquee-title">Trusted by engineers & teams using next-gen stacks</div>
        <div className="marquee-track-wrap">
          <div className="marquee-content">
            <div className="marquee-logo"><SiGooglecloud style={{ color: "#4285F4", fontSize: "1.4rem" }} /> <span>Google Cloud</span></div>
            <div className="marquee-logo"><FaMicrosoft style={{ color: "#00A4EF", fontSize: "1.4rem" }} /> <span>Microsoft</span></div>
            <div className="marquee-logo"><SiFirebase style={{ color: "#FFCA28", fontSize: "1.4rem" }} /> <span>Firebase RTDB</span></div>
            <div className="marquee-logo"><SiReact style={{ color: "#61DAFB", fontSize: "1.4rem" }} /> <span>React 18</span></div>
            <div className="marquee-logo"><SiOpenai style={{ color: "#10A37F", fontSize: "1.4rem" }} /> <span>OpenAI & Gemini</span></div>
            <div className="marquee-logo"><SiNodedotjs style={{ color: "#5FA04E", fontSize: "1.4rem" }} /> <span>Node.js</span></div>
            {/* Duplicated for seamless infinite loop */}
            <div className="marquee-logo"><SiGooglecloud style={{ color: "#4285F4", fontSize: "1.4rem" }} /> <span>Google Cloud</span></div>
            <div className="marquee-logo"><FaMicrosoft style={{ color: "#00A4EF", fontSize: "1.4rem" }} /> <span>Microsoft</span></div>
            <div className="marquee-logo"><SiFirebase style={{ color: "#FFCA28", fontSize: "1.4rem" }} /> <span>Firebase RTDB</span></div>
            <div className="marquee-logo"><SiReact style={{ color: "#61DAFB", fontSize: "1.4rem" }} /> <span>React 18</span></div>
            <div className="marquee-logo"><SiOpenai style={{ color: "#10A37F", fontSize: "1.4rem" }} /> <span>OpenAI & Gemini</span></div>
            <div className="marquee-logo"><SiNodedotjs style={{ color: "#5FA04E", fontSize: "1.4rem" }} /> <span>Node.js</span></div>
          </div>
        </div>
      </section>

      {/* 📢 RELEASE ANNOUNCEMENT SECTION: BHARAT CONNECT v3.0 */}
      <section className="v2-announcement-section" id="v3-announcement" data-aos="fade-up">
        <div className="v3-container">
          <div className="v2-announcement-card">
            <div className="v2-announcement-badge">
              <FaRobot className="v2-badge-icon" /> Official Release Announcement
            </div>
            
            <div className="v2-announcement-header">
              <h2>Bharat Connect v3.0 • Powered by Sampark AI</h2>
              <span className="v2-release-pill">v3.0 LIVE</span>
            </div>

            <p className="v2-announcement-subtitle">
              We are excited to unveil <strong>Bharat Connect v3.0</strong>, natively powered by our flagship <strong>Sampark AI Engine</strong>. Engineered specifically for high-speed messaging across India with enterprise end-to-end encryption, multi-lingual AI assistance, and instant zero-latency data synchronization.
            </p>

            <div className="v2-features-grid">
              <div className="v2-feature-item">
                <div className="v2-feature-icon"><FaRobot style={{ color: '#00a884' }} /></div>
                <div className="v2-feature-text">
                  <h4>Sampark AI 3.0 Integration</h4>
                  <p>Mention <code>@SamparkAI</code> directly in any chat for real-time code generation, intelligent summaries, and contextual Indian language assistance.</p>
                </div>
              </div>

              <div className="v2-feature-item">
                <div className="v2-feature-icon"><FaLock style={{ color: '#00a884' }} /></div>
                <div className="v2-feature-text">
                  <h4>End-to-End Encrypted Grid</h4>
                  <p>Military-grade SSL/TLS and Firebase RTDB security protocols protecting every message, media attachment, and voice payload.</p>
                </div>
              </div>

              <div className="v2-feature-item">
                <div className="v2-feature-icon"><FaBolt style={{ color: '#00a884' }} /></div>
                <div className="v2-feature-text">
                  <h4>In-Memory Data Sync</h4>
                  <p>Background data refreshing with zero full-page reloads, instant unread badge syncing, and active user presence tracking.</p>
                </div>
              </div>

              <div className="v2-feature-item">
                <div className="v2-feature-icon"><FaMobileAlt style={{ color: '#00a884' }} /></div>
                <div className="v2-feature-text">
                  <h4>Sleek Glassmorphism Interface</h4>
                  <p>Custom filter pills (All, Unread, Favourites, Pinned), fixed 60px header navigation, and intuitive dark/light theme switching.</p>
                </div>
              </div>
            </div>

            <div className="v2-announcement-actions">
              <Link to="/register" className="v3-btn-primary">
                Experience v3.0 Now <FaArrowRight />
              </Link>
              <Link to="/SamparkAI" className="v3-btn-secondary">
                Launch Sampark AI Hub
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 📊 4. LIVE ANALYTICS DASHBOARD */}
      <section className="dash-section" id="analytics">
        <div className="v3-container dash-grid">
          <div data-aos="fade-right">
            <span className="v3-section-tag">Realtime Telemetry</span>
            <h2 className="v3-section-title">Live Platform Dashboard</h2>
            <p style={{ color: "var(--bc-text-muted)", fontSize: "1.1rem", marginBottom: "24px" }}>
              Track platform metrics, message delivery rates, online connections, and AI inference latency in real time.
            </p>
            <div style={{ display: "flex", gap: "24px" }}>
              <div>
                <div style={{ color: "var(--bc-primary)", fontWeight: 800, fontSize: "1.4rem" }}>&lt; 48ms</div>
                <div style={{ fontSize: "0.85rem", color: "var(--bc-text-muted)" }}>Edge Network Latency</div>
              </div>
              <div>
                <div style={{ color: "var(--bc-accent)", fontWeight: 800, fontSize: "1.4rem" }}>99.99%</div>
                <div style={{ fontSize: "0.85rem", color: "var(--bc-text-muted)" }}>Uptime Guarantee</div>
              </div>
            </div>
          </div>

          <div className="dash-card" data-aos="fade-left">
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
              <span style={{ fontWeight: 700, fontSize: "0.95rem" }}><FaChartLine /> Analytics Center</span>
              <span style={{ color: "var(--bc-primary)", fontSize: "0.85rem" }}>● Live Sync</span>
            </div>

            <div className="dash-stat-row">
              <div className="dash-stat-item">
                <div className="dash-num">120K+</div>
                <div className="dash-lbl">Active Users</div>
              </div>
              <div className="dash-stat-item">
                <div className="dash-num">2.8M+</div>
                <div className="dash-lbl">Messages Delivered</div>
              </div>
              <div className="dash-stat-item">
                <div className="dash-num">45K+</div>
                <div className="dash-lbl">Online Sessions</div>
              </div>
              <div className="dash-stat-item">
                <div className="dash-num">850K+</div>
                <div className="dash-lbl">AI Requests</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 🍱 5. FEATURES BENTO GRID */}
      <section className="bento-v3-section" id="features">
        <div className="v3-container">
          <div style={{ textAlign: "center", maxWidth: "650px", margin: "0 auto" }}>
            <span className="v3-section-tag">Core Features</span>
            <h2 className="v3-section-title">Engineered For Scale & Speed</h2>
          </div>

          <div className="bento-v3-grid">
            <div className="bento-v3-card col-2" data-aos="fade-up">
              <div className="bento-v3-icon" style={{ background: "rgba(124, 58, 237, 0.15)", color: "#a78bfa" }}><FaRobot /></div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, marginBottom: "8px" }}>Sampark AI Assistant</h3>
              <p style={{ color: "var(--bc-text-muted)" }}>
                Built-in Indian context AI assistant with a 10-message continuity context buffer, code generation, and multi-lingual translation.
              </p>
            </div>

            <div className="bento-v3-card" data-aos="fade-up" data-aos-delay="100">
              <div className="bento-v3-icon"><FaComments /></div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, marginBottom: "8px" }}>Realtime Chat</h3>
              <p style={{ color: "var(--bc-text-muted)" }}>
                Sub-100ms sync with Firebase Realtime Database and live typing indicators.
              </p>
            </div>

            <div className="bento-v3-card" data-aos="fade-up" data-aos-delay="200">
              <div className="bento-v3-icon"><FaLock /></div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, marginBottom: "8px" }}>End-to-End Encryption</h3>
              <p style={{ color: "var(--bc-text-muted)" }}>
                256-bit encryption ensuring strict data isolation and privacy.
              </p>
            </div>

            <div className="bento-v3-card" data-aos="fade-up" data-aos-delay="300">
              <div className="bento-v3-icon" style={{ background: "rgba(37, 99, 235, 0.15)", color: "#3b82f6" }}><FaCloud /></div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, marginBottom: "8px" }}>Cloud Auto Sync</h3>
              <p style={{ color: "var(--bc-text-muted)" }}>
                Seamless real-time message persistence across mobile, PWA, and desktop interfaces.
              </p>
            </div>

            <div className="bento-v3-card col-3" data-aos="fade-up" data-aos-delay="400">
              <div className="bento-v3-icon"><FaUsers /></div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, marginBottom: "8px" }}>Smart Communities & Groups</h3>
              <p style={{ color: "var(--bc-text-muted)" }}>
                Discover, build, and join public/private community hubs with live membership badges and member directories.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 🧠 6. REDEVELOPED BHARAT AI SUITE SECTION */}
      <section className="ai-v3-section" id="ai">
        <div className="v3-container">
          <div style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto" }}>
            <span className="v3-section-tag" style={{ color: "#a78bfa" }}>Bharat AI Suite</span>
            <h2 className="v3-section-title">Powered By Sampark AI Engine v3.0</h2>
            <p style={{ color: "var(--bc-text-muted)", fontSize: "1.1rem" }}>
              India's first messaging-integrated AI assistant featuring a 10-message thread memory buffer and Gemini REST failover engine.
            </p>
          </div>

          <div className="ai-redevelop-grid">
            {/* Left: Interactive Demo Sandbox */}
            <div className="ai-sandbox-card" data-aos="fade-right">
              <div className="ai-demo-tabs">
                <button
                  className={`ai-tab-btn ${aiDemoTab === "summary" ? "active" : ""}`}
                  onClick={() => setAiDemoTab("summary")}
                >
                  <FaHistory /> Thread Summarizer
                </button>
                <button
                  className={`ai-tab-btn ${aiDemoTab === "code" ? "active" : ""}`}
                  onClick={() => setAiDemoTab("code")}
                >
                  <FaCode /> Code Gen
                </button>
                <button
                  className={`ai-tab-btn ${aiDemoTab === "trans" ? "active" : ""}`}
                  onClick={() => setAiDemoTab("trans")}
                >
                  <FaLanguage /> Translation
                </button>
              </div>

              <div className="ai-terminal-output">
                {aiDemoTab === "summary" && (
                  <div>
                    <div className="ai-cmd-prompt">&gt; @SamparkAI summarize today's engineering sync</div>
                    <div className="ai-output-header">🤖 Sampark AI Output:</div>
                    <ul className="ai-output-list">
                      <li>Firebase Realtime Database failover 2.0 active</li>
                      <li>sub-100ms latency verified on Indian nodes</li>
                      <li>10-message continuity buffer online</li>
                    </ul>
                  </div>
                )}
                {aiDemoTab === "code" && (
                  <div>
                    <div className="ai-cmd-prompt">&gt; @SamparkAI generate Firebase RTDB listener</div>
                    <div className="ai-code-block">
                      const chatRef = ref(db, `chats/$&#123;chatId&#125;`);<br />
                      onValue(chatRef, (snapshot) =&gt; &#123;<br />
                      &nbsp;&nbsp;const messages = snapshot.val();<br />
                      &nbsp;&nbsp;updateChatStream(messages);<br />
                      &#125;);
                    </div>
                  </div>
                )}
                {aiDemoTab === "trans" && (
                  <div>
                    <div className="ai-cmd-prompt">&gt; @SamparkAI translate "Welcome to Bharat Connect"</div>
                    <div className="ai-trans-output">
                      🇮🇳 "भारत कनेक्ट में आपका स्वागत है!"
                    </div>
                    <div className="ai-trans-sub">Supports 12+ Indian Regional Languages.</div>
                  </div>
                )}
              </div>
            </div>

            {/* Right: AI Feature Pillars */}
            <div className="ai-pillars-content" data-aos="fade-left">
              <div className="ai-orb-wrap" style={{ height: "180px", marginBottom: "20px" }}>
                <div className="ai-orb" style={{ width: "120px", height: "120px" }}></div>
              </div>

              <div className="ai-pillars-grid">
                <div className="ai-pillar-pill"><FaCheck style={{ color: "#a78bfa" }} /> 10-Msg Memory Buffer</div>
                <div className="ai-pillar-pill"><FaCheck style={{ color: "#00a884" }} /> Gemini REST Failover</div>
                <div className="ai-pillar-pill"><FaCheck style={{ color: "#3b82f6" }} /> Indian-Aware Persona</div>
                <div className="ai-pillar-pill"><FaCheck style={{ color: "#ff9933" }} /> Prism Code Syntax</div>
              </div>

              <Link to="/SamparkAI" className="v3-btn-primary" style={{ background: "linear-gradient(135deg, var(--bc-purple), var(--bc-accent))" }}>
                Launch Sampark AI Portal <FaRobot />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 📈 7. STATISTICS SECTION */}
      <section className="stats-v3-section">
        <div className="v3-container">
          <div className="stats-v3-grid">
            <div>
              <div className="stats-v3-num">120K+</div>
              <div className="stats-v3-lbl">Registered Users</div>
            </div>
            <div>
              <div className="stats-v3-num">2.8M+</div>
              <div className="stats-v3-lbl">Messages Delivered</div>
            </div>
            <div>
              <div className="stats-v3-num">99.99%</div>
              <div className="stats-v3-lbl">Uptime SLA</div>
            </div>
            <div>
              <div className="stats-v3-num">48ms</div>
              <div className="stats-v3-lbl">Average Latency</div>
            </div>
          </div>
        </div>
      </section>

      {/* 📊 8. INTEGRATION REPORT SECTION */}
      <IntegrationReport />

      {/* ⭐ 9. TESTIMONIALS MARQUEE */}
      <section className="testi-v3-section">
        <div className="v3-container">
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <span className="v3-section-tag">Testimonials</span>
            <h2 className="v3-section-title">Loved By Engineers & Creators</h2>
          </div>

          <div style={{ overflow: "hidden" }}>
            <div className="testi-track">
              <div className="testi-v3-card">
                <FaQuoteLeft style={{ color: "var(--bc-primary)", marginBottom: "12px" }} />
                <p style={{ fontStyle: "italic", marginBottom: "16px" }}>
                  "The fastest messaging architecture I've integrated. Bharat Connect is a game changer."
                </p>
                <strong>Arjun Mehta</strong>
                <div style={{ fontSize: "0.8rem", color: "var(--bc-text-muted)" }}>Lead Developer, TechFlow</div>
              </div>

              <div className="testi-v3-card">
                <FaQuoteLeft style={{ color: "var(--bc-primary)", marginBottom: "12px" }} />
                <p style={{ fontStyle: "italic", marginBottom: "16px" }}>
                  "Security and speed are top-notch. PWA installation feels like a native app."
                </p>
                <strong>Priya Sharma</strong>
                <div style={{ fontSize: "0.8rem", color: "var(--bc-text-muted)" }}>CTO, InnovateIN</div>
              </div>

              <div className="testi-v3-card">
                <FaQuoteLeft style={{ color: "var(--bc-primary)", marginBottom: "12px" }} />
                <p style={{ fontStyle: "italic", marginBottom: "16px" }}>
                  "Zero-latency sync at its best. Extremely stable platform."
                </p>
                <strong>Vikram Singh</strong>
                <div style={{ fontSize: "0.8rem", color: "var(--bc-text-muted)" }}>Security Lead, SecureNet</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ❓ 10. FAQ ACCORDION */}
      <section className="faq-v3-section">
        <div className="v3-container">
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <span className="v3-section-tag">Questions</span>
            <h2 className="v3-section-title">Frequently Asked Questions</h2>
          </div>

          <div className="faq-v3-wrap">
            {[
              { q: "Is my data secure during transit?", a: "Every packet is protected by TLS 1.3 and 256-bit AES encryption backed by Firebase security rules." },
              { q: "Does the PWA support full offline mode?", a: "Yes. Service Workers cache your history and assets locally." },
              { q: "What is Sampark AI?", a: "Sampark AI is our native AI engine powered by Gemini v1 REST API with automatic failover." },
              { q: "Can I use it across multiple devices?", a: "Log in on any PWA-enabled device to instantly restore your sessions." }
            ].map((faq, idx) => (
              <div className="faq-v3-item" key={idx}>
                <div className="faq-v3-q" onClick={() => toggleFaq(idx)}>
                  <span>{faq.q}</span>
                  {openFaq === idx ? <FaChevronUp style={{ color: "var(--bc-primary)" }} /> : <FaChevronDown />}
                </div>
                {openFaq === idx && <div className="faq-v3-a">{faq.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🏁 11. CTA SECTION */}
      <section className="cta-v3-section">
        <div className="v3-container">
          <div className="cta-v3-box">
            <h2 className="cta-v3-title">Ready To Join Bharat Connect?</h2>
            <p style={{ color: "var(--bc-text-muted)", fontSize: "1.15rem", marginBottom: "32px" }}>
              Experience the next generation of real-time messaging & AI collaboration.
            </p>
            <Link to="/register" className="v3-btn-primary">
              Create Account Free <FaPaperPlane />
            </Link>
          </div>
        </div>
      </section>

      {/* 👣 12. FOOTER */}
      <footer className="footer-v3">
        <div className="v3-container">
          <div className="footer-v3-grid">
            <div>
              <h3 className="footer-v3-brand-title">🇮🇳 Bharat Connect</h3>
              <p className="footer-v3-brand-desc">
                Connecting Bharat with intelligent real-time messaging, AI collaboration, and community networks.
              </p>
            </div>

            <div>
              <h4 className="footer-v3-col-title">Platform</h4>
              <ul className="footer-v3-links">
                <li><a href="#features">Features</a></li>
                <li><a href="#analytics">Live Analytics</a></li>
                <li><a href="#ai">Bharat AI</a></li>
                <li><Link to="/docs">Docs</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="footer-v3-col-title">Resources</h4>
              <ul className="footer-v3-links">
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/support">Support Desk</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="footer-v3-col-title">Socials</h4>
              <div className="footer-v3-social-icons">
                <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="footer-v3-social-icon-btn" aria-label="GitHub" title="GitHub">
                  <FaGithub />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-v3-social-icon-btn" aria-label="Twitter" title="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-v3-social-icon-btn" aria-label="LinkedIn" title="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="footer-v3-social-icon-btn" aria-label="Discord" title="Discord">
                  <FaDiscord />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-v3-btm">
            <div>© {new Date().getFullYear()} Bharat Connect & Sampark AI. All rights reserved.</div>
            <Link to="/version" className="footer-v3-version">
              v3.0.0 • AI v2.0.0
            </Link>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default Home;
